export default [
  { field: 'datetime', headerName: 'Datetime' },
  { field: 'patient_id', headerName: 'Patient ID' },
  { field: 'patient', headerName: 'Patient' },
  { field: 'event_name', headerName: 'Event Name' },
  { field: 'insurance_name', headerName: 'Insurance Name' },
  { field: 'service', headerName: 'Service' },
  { field: 'cpt_code', headerName: 'Cpt Code' },
  { field: 'provider', headerName: 'Provider' },
  { field: 'balance', headerName: 'Balance' },
  { field: 'status', headerName: 'Status' }
];
